// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import "./App.css";
import Layout from "./Layout";
import SidebarLayout from "./SidebarLayout"; 
import Bio from "./Bio";
import Works from "./Works"; 
import CategoryPage from "./CategoryPage"; 
import ArtworkDetails from "./ArtworkDetails"; 
import CV from "./CV";
import Contact from "./Contact";
import { PuaProvider } from "./PuaContext";
import artworksData from "./data/artworksData.json"; 

function AppRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        {/* Página inicial con Layout */}
        <Route path="/" element={<Layout />} />

        {/* Rutas con SidebarLayout */}
        <Route path="/bio" element={<SidebarLayout />}>
          <Route index element={<Bio />} />
        </Route>
        <Route path="/cv" element={<SidebarLayout />}>
          <Route index element={<CV />} />
        </Route>
        <Route path="/contacto" element={<SidebarLayout />}>
          <Route index element={<Contact />} />
        </Route>

        {/* Página principal de obras */}
        <Route path="/obras" element={<SidebarLayout />}>
          <Route index element={<Works />} />
          {/* Rutas para categorías específicas */}
          <Route
            path=":category"
            element={<CategoryPage artworks={artworksData} />}
          />
          {/* Rutas para detalles de una obra */}
          <Route
            path=":category/:title"
            element={<ArtworkDetails artworks={artworksData} />}
          />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

export default function WrappedApp() {
  return (
    <PuaProvider>
      <Router>
        <AppRoutes />
      </Router>
    </PuaProvider>
  );
}